// extracted by mini-css-extract-plugin
module.exports = {"login":"login_login__2IF2o"};